// Mock listings data - extracted from HTML file
// In production, this would come from an API

import { Listing } from '../types/listing.types';

export const MOCK_LISTINGS: Listing[] = [
  {
    id: 'listing-001',
    listingNumber: 'AQ-2024-001',
    title: 'Franchise de Restauration Rapide Établie',
    description:
      "Franchise bien établie dans un emplacement premium avec fort achalandage. Plus de 15 ans d'opération. Équipe stable de 18 employés. Opportunité de croissance avec services de livraison en expansion.",
    category: 'restaurant',
    location: {
      city: 'Montréal',
      state: 'QC',
      country: 'CA',
    },
    financials: {
      price: 850000,
      currency: 'CAD',
      cashFlow: 185000,
      sde: 210000,
      ebitda: 195000,
      grossRevenue: 1800000,
      revenueGrowth3yr: 12,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=500&fit=crop',
    imageCount: 12,
    badges: [
      { type: 'seller_financing', label: 'Seller Financing', variant: 'green' },
      { type: 'semi_absentee', label: 'Semi-Absentee', variant: 'purple' },
    ],
    preFinancingOffers: 4,
    detailUrl: '/listings/restaurant-franchise',
    yearEstablished: 2008,
    employeeCount: 18,
    employeeCountRange: '10-24',
    status: 'active',
    naicsCode: '722513',
  },
  {
    id: 'listing-002',
    listingNumber: 'AQ-2024-002',
    title: 'Plateforme SaaS B2B de Gestion de Projets',
    description:
      "Plateforme SaaS rentable avec 850+ clients actifs. Revenus récurrents mensuels (MRR) de $95K. Taux de rétention de 94%. Technologie moderne et scalable. Équipe technique de 8 personnes.",
    category: 'technology',
    location: {
      city: 'Austin',
      state: 'TX',
      country: 'US',
    },
    financials: {
      price: 2400000,
      currency: 'USD',
      cashFlow: 520000,
      sde: 545000,
      ebitda: 510000,
      grossRevenue: 1140000,
      revenueGrowth3yr: 35,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=500&fit=crop',
    imageCount: 8,
    badges: [
      { type: 'category', label: 'TECHNOLOGIE', variant: 'gray' },
      { type: 'e2_visa', label: 'Visa E2', variant: 'blue' },
      { type: 'absentee_owner', label: 'Absentee Owner', variant: 'purple' },
    ],
    preFinancingOffers: 7,
    detailUrl: '/listings/saas-platform',
    yearEstablished: 2018,
    employeeCount: 8,
    employeeCountRange: '1-9',
    status: 'active',
    naicsCode: '541512',
  },
  {
    id: 'listing-003',
    listingNumber: 'AQ-2024-003',
    title: 'Entreprise de Construction Résidentielle et Commerciale',
    description:
      "Entreprise de construction établie depuis 22 ans. Portfolio de projets diversifié. Équipement moderne inclus (valeur de $400K). Contrats signés pour 18 mois. Excellente réputation locale.",
    category: 'construction',
    location: {
      city: 'Calgary',
      state: 'AB',
      country: 'CA',
    },
    financials: {
      price: 1650000,
      currency: 'CAD',
      cashFlow: 380000,
      sde: 395000,
      ebitda: 390000,
      grossRevenue: 4200000,
      revenueGrowth3yr: 8,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&h=500&fit=crop',
    imageCount: 15,
    badges: [
      { type: 'seller_financing', label: 'Seller Financing', variant: 'green' },
    ],
    preFinancingOffers: 5,
    detailUrl: '/listings/construction-company',
    yearEstablished: 2003,
    employeeCount: 32,
    employeeCountRange: '25-49',
    status: 'active',
    naicsCode: '236220',
  },
  {
    id: 'listing-004',
    listingNumber: 'AQ-2024-004',
    title: 'Clinique Dentaire Multi-Praticiens',
    description:
      "Clinique dentaire moderne avec 3 dentistes et personnel de soutien. Base de patients fidèles de 2,500+. Équipement à la fine pointe. Emplacement stratégique avec parking. Croissance annuelle constante de 8%.",
    category: 'healthcare',
    location: {
      city: 'Denver',
      state: 'CO',
      country: 'US',
    },
    financials: {
      price: 1200000,
      currency: 'USD',
      cashFlow: 290000,
      sde: 305000,
      ebitda: 295000,
      grossRevenue: 1850000,
      revenueGrowth3yr: 8,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&h=500&fit=crop',
    imageCount: 10,
    badges: [
      { type: 'category', label: 'SANTÉ', variant: 'gray' },
      { type: 'e2_visa', label: 'Visa E2', variant: 'blue' },
    ],
    preFinancingOffers: 6,
    detailUrl: '/listings/dental-clinic',
    yearEstablished: 2010,
    employeeCount: 12,
    employeeCountRange: '10-24',
    status: 'active',
    naicsCode: '621210',
  },
  {
    id: 'listing-005',
    listingNumber: 'AQ-2024-005',
    title: 'Commerce en Ligne - Produits de Beauté Naturels',
    description:
      "E-commerce établi avec marque forte et base de clients fidèles. Plus de 15,000 commandes annuelles. Présence sur Amazon et boutique Shopify. Inventaire inclus. Marges brutes de 65%. Automatisation avancée.",
    category: 'ecommerce',
    location: {
      city: 'Vancouver',
      state: 'BC',
      country: 'CA',
    },
    financials: {
      price: 450000,
      currency: 'CAD',
      cashFlow: 125000,
      sde: 130000,
      ebitda: 128000,
      grossRevenue: 980000,
      revenueGrowth3yr: 22,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&h=500&fit=crop',
    imageCount: 6,
    badges: [
      { type: 'seller_financing', label: 'Seller Financing', variant: 'green' },
      { type: 'home_based', label: 'Home-Based', variant: 'orange' },
    ],
    preFinancingOffers: 3,
    detailUrl: '/listings/ecommerce-beauty',
    yearEstablished: 2017,
    employeeCount: 4,
    employeeCountRange: '1-9',
    status: 'active',
    naicsCode: '454110',
  },
  {
    id: 'listing-006',
    listingNumber: 'AQ-2024-006',
    title: 'Fabricant de Pièces Automobiles Spécialisées',
    description:
      "Fabricant établi avec 30 ans d'expérience. Contrats long-terme avec constructeurs automobiles majeurs. Installations de 45,000 pi² avec équipement CNC moderne. Certifications ISO 9001 et IATF 16949.",
    category: 'manufacturing',
    location: {
      city: 'Detroit',
      state: 'MI',
      country: 'US',
    },
    financials: {
      price: 3200000,
      currency: 'USD',
      cashFlow: 750000,
      sde: 785000,
      ebitda: 770000,
      grossRevenue: 6800000,
      revenueGrowth3yr: 6,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=500&fit=crop',
    imageCount: 18,
    badges: [
      { type: 'category', label: 'FABRICATION', variant: 'gray' },
      { type: 'e2_visa', label: 'Visa E2', variant: 'blue' },
    ],
    preFinancingOffers: 8,
    detailUrl: '/listings/automotive-manufacturer',
    yearEstablished: 1995,
    employeeCount: 65,
    employeeCountRange: '50+',
    status: 'active',
    naicsCode: '336390',
  },
  // ─── UK ──────────────────────────────────────────────────────────────
  {
    id: '3 Boutique Hotels & Restaurant — Central London',
    listingNumber: 'AQ-2024-007',
    title: 'Premium Hospitality Group — London',
    description: 'Established boutique hotel and restaurant group in Central London. 3 properties, loyal corporate clientele, strong TripAdvisor ratings. Management team in place. Ideal for international buyer seeking UK hospitality foothold.',
    category: 'hospitality',
    location: { city: 'London', state: 'England', country: 'GB' },
    financials: {
      price: 2800000,
      currency: 'GBP',
      cashFlow: 420000,
      sde: 480000,
      ebitda: 455000,
      grossRevenue: 3200000,
      revenueGrowth3yr: 9,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=500&fit=crop',
    imageCount: 14,
    badges: [
  { type: 'category', label: 'HOSPITALITY', variant: 'gray' },
  { type: 'seller_financing', label: 'UK Innovator Founder Visa', variant: 'blue' },
],
    preFinancingOffers: 3,
    detailUrl: '/listings/listing-007',
    yearEstablished: 2008,
    employeeCount: 42,
    employeeCountRange: '25-50',
    status: 'active',
    naicsCode: '721110',
  },
  {
    id: 'Award-Winning Digital Agency — 85% Recurring Revenue',
    listingNumber: 'AQ-2024-008',
    title: 'Digital Marketing Agency — Manchester',
    description: 'Award-winning digital agency specialising in SEO, PPC and social media for UK retail brands. 85% recurring revenue. Team of 12 remote-first professionals. Strong pipeline of new business.',
    category: 'technology',
    location: { city: 'Manchester', state: 'England', country: 'GB' },
    financials: {
      price: 950000,
      currency: 'GBP',
      cashFlow: 210000,
      sde: 245000,
      ebitda: 228000,
      grossRevenue: 890000,
      revenueGrowth3yr: 22,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop',
    imageCount: 8,
    badges: [
  { type: 'category', label: 'TECHNOLOGY', variant: 'gray' },
  { type: 'e2_visa', label: 'UK Global Talent Visa', variant: 'blue' },
],
    preFinancingOffers: 2,
detailUrl: '/listings/listing-008',
    yearEstablished: 2014,
    employeeCount: 12,
    employeeCountRange: '10-25',
    status: 'active',
    naicsCode: '541810',
  },
  // ─── AUSTRALIE ───────────────────────────────────────────────────────
  {
    id: 'Commercial Cleaning — 120 Corporate Clients, 18 Yrs',
    listingNumber: 'AQ-2024-009',
    title: 'Commercial Cleaning Services — Sydney',
    description: 'Well-established commercial cleaning company serving 120+ corporate clients across Greater Sydney. 95% client retention rate. Fully systemised operations with trained staff of 35. Owner retiring after 18 years.',
    category: 'services',
    location: { city: 'Sydney', state: 'NSW', country: 'AU' },
    financials: {
      price: 1200000,
      currency: 'AUD',
      cashFlow: 285000,
      sde: 320000,
      ebitda: 298000,
      grossRevenue: 2100000,
      revenueGrowth3yr: 8,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&h=500&fit=crop',
    imageCount: 10,
    badges: [
  { type: 'category', label: 'SERVICES', variant: 'gray' },
  { type: 'seller_financing', label: 'Seller Financing', variant: 'green' },
  { type: 'e2_visa', label: 'Business Innovation Visa 188', variant: 'blue' },
],
    preFinancingOffers: 4,
    detailUrl: '/listings/listing-009',
    yearEstablished: 2006,
    employeeCount: 35,
    employeeCountRange: '25-50',
    status: 'active',
    naicsCode: '561720',
  },
  {
    id: 'Specialty Coffee Roaster & Wholesale — 200+ Café Clients',
    listingNumber: 'AQ-2024-010',
    title: 'Specialty Coffee Roaster & Wholesale — Melbourne',
    description: 'Premium specialty coffee roaster supplying 200+ cafés, restaurants and offices across Victoria and NSW. Proprietary blends, strong brand recognition, e-commerce channel growing 35% YoY. Relocatable operations.',
    category: 'food_beverage',
    location: { city: 'Melbourne', state: 'VIC', country: 'AU' },
    financials: {
      price: 780000,
      currency: 'AUD',
      cashFlow: 195000,
      sde: 225000,
      ebitda: 208000,
      grossRevenue: 1450000,
      revenueGrowth3yr: 18,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&h=500&fit=crop',
    imageCount: 11,
    badges: [
  { type: 'category', label: 'FOOD & BEVERAGE', variant: 'gray' },
  { type: 'e2_visa', label: 'Business Innovation Visa 188', variant: 'blue' },
],
    preFinancingOffers: 3,
    detailUrl: '/listings/listing-010',
    yearEstablished: 2011,
    employeeCount: 14,
    employeeCountRange: '10-25',
    status: 'active',
    naicsCode: '311920',
  },
  // ─── EUROPE FR ───────────────────────────────────────────────────────
  {
    id: 'Cabinet Comptable — 180 Clients PME, 96% Rétention',
    listingNumber: 'AQ-2024-011',
    title: 'Cabinet Comptable Indépendant — Lyon',
    description: "Cabinet comptable bien établi au cœur de Lyon. Portefeuille de 180 clients PME fidèles. Équipe de 8 professionnels qualifiés. Taux de rétention de 96%. Idéal pour CPA souhaitant s'établir en France ou pour regroupement de cabinets.",
    category: 'professional_services',
    location: { city: 'Lyon', state: 'Auvergne-Rhône-Alpes', country: 'FR' },
    financials: {
      price: 650000,
      currency: 'EUR',
      cashFlow: 168000,
      sde: 195000,
      ebitda: 180000,
      grossRevenue: 720000,
      revenueGrowth3yr: 7,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=500&fit=crop',
    imageCount: 9,
    badges: [
  { type: 'category', label: 'SERVICES PROFESSIONNELS', variant: 'gray' },
  { type: 'seller_financing', label: 'Financement vendeur', variant: 'green' },
  { type: 'e2_visa', label: 'French Tech Visa', variant: 'blue' },
],
    preFinancingOffers: 2,
detailUrl: '/listings/listing-011',
    yearEstablished: 2003,
    employeeCount: 8,
    employeeCountRange: '5-10',
    status: 'active',
    naicsCode: '541211',
  },
  {
    id: 'Agence Branding & Design — Clientèle Luxe & Tech',
    listingNumber: 'AQ-2024-012',
    title: 'Agence de Communication & Design — Paris',
    description: "Agence créative parisienne spécialisée en branding, design graphique et stratégie digitale. Clientèle internationale incluant des marques de luxe et startups tech. 90% de revenus récurrents. 6 designers senior en place.",
    category: 'technology',
    location: { city: 'Paris', state: 'Île-de-France', country: 'FR' },
    financials: {
      price: 1100000,
      currency: 'EUR',
      cashFlow: 265000,
      sde: 310000,
      ebitda: 285000,
      grossRevenue: 1250000,
      revenueGrowth3yr: 15,
      hasPositiveCashFlow: true,
    },
    imageUrl: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=500&fit=crop',
    imageCount: 13,
    badges: [
  { type: 'category', label: 'TECHNOLOGIE', variant: 'gray' },
  { type: 'e2_visa', label: 'French Tech Visa', variant: 'blue' },
],
    preFinancingOffers: 5,
detailUrl: '/listings/listing-012',
    yearEstablished: 2012,
    employeeCount: 11,
    employeeCountRange: '10-25',
    status: 'active',
    naicsCode: '541430',
  },
];
